import { JsonSectionsRepository } from "../../repositories/implementations/JsonSectionsRepository";
import { GetSectionUseCase } from "./GetSectionUseCase";

export const getSectionUseCase =  new GetSectionUseCase(
    new JsonSectionsRepository()
);